import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';

const ordinancesData = [
    {
    title: "ORDONNANCE MINISTÉRIELLE N° 540/95/481/2024 DU 27/09/2024 PORTANT NOMINATION DES MEMBRES DES GROUPES DE TRAVAIT STATISTIQUES (GTS)",
    principalLink: "/documents/ordinances/Ordonnance_Ministerielle_Nomination_des_membres_des_GTS.pdf",
    image: 'assets/ordinances/collecte.PNG', 
    description: "Ordonnance ministérielle du 27 septembre 2024 portant nomination des membres des Groupes de Travail Statistiques (GTS).",
    date: "2024-09-27",
    publicationDate: "2024-09-27"
  },
  {
    title: "ORDONNANCE MINISTÉRIELLE N° 214/CAB/SN/1165 DU 09/06/2016 PORTANT AFFECTATION DE DIFFÉRENTS CADRES STATISTICIENS ET DÉMOGRAPHES DE L'INSTITUT DE LA STATISTIQUE ET DE L'ÉTUDE ÉCONOMIQUE DU BURUNDI (ISTEEBU) DANS LES SERVICES STATISTIQUES MINISTÉRIELS",
    principalLink: "/documents/ordinances/ordonance214cabsen1165.pdf",
    image: 'assets/ordinances/collecte.PNG', 
    description: "Cadre légal pour l'affectation des experts de l'ISTEEBU dans les ministères, optimisant l'expertise statistique au sein de l'administration publique.",
    date: "2016-06-09",
    publicationDate: "2016-06-09"
  },
  {
    title: "ORDONNANCE MINISTÉRIELLE N° 540/1643 DU 25/11/2023 PORTANT MODALITÉS D'OBTENTION DU VISA STATISTIQUE POUR LES ENQUÊTES STATISTIQUES AU BURUNDI",
    principalLink: "/documents/ordinances/ordonance540cabsen1643.pdf",
    image: 'assets/ordinances/protection.PNG',
    description: "Réglementation des autorisations d'enquêtes statistiques, garantissant leur conformité aux normes nationales et internationales.",
    date: "2023-11-25",
    publicationDate: "2023-11-25"
  },
  {
    title: "ORDONNANCE MINISTÉRIELLE N° 214/1225/2016 DU 27/06/2016 PORTANT MISE EN PLACE DE PROCÉDURES DE SUIVI DE LA QUALITÉ DE LA PRODUCTION DES STATISTIQUES OFFICIELLES AU BURUNDI",
    principalLink: "/documents/ordinances/ordonance21412252016.pdf",
    image: 'assets/ordinances/protection.PNG',
    description: "Mise en place de procédures strictes pour assurer la fiabilité et la transparence des données statistiques produites au Burundi.",
    date: "2016-06-27",
    publicationDate: "2016-06-27"
  },
];

function Ordinances() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredOrdinances, setFilteredOrdinances] = useState(ordinancesData);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    let filtered;

    if (year === 'Tous') {
      filtered = ordinancesData;
    } else {
      filtered = ordinancesData.filter((ordinance) => {
        const ordinanceYear = new Date(ordinance.date).getFullYear();
        return ordinanceYear === parseInt(year);
      });
    }
    filtered.sort((a, b) => new Date(b.publicationDate) - new Date(a.publicationDate));
    setFilteredOrdinances(filtered);
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C',
      },
      h4: {
        fontWeight: '600',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Ordonnances Relatives au Système Statistique National
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            L'ensemble des ordonnances en vigueur concernant le système statistique national (SSN). Vous y trouverez des textes réglementaires importants qui encadrent la collecte, l'analyse et la diffusion des données statistiques, ainsi que des ressources essentielles pour comprendre le cadre légal et opérationnel du SSN.
          </Typography>
          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionnez par l'année d'adoption</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionnez par l'année d'adoption"
            >
              <MenuItem value="Tous">Toutes les ordonnances</MenuItem>
              {[...new Set(ordinancesData.map((ordinance) => new Date(ordinance.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

        
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredOrdinances.slice(0, visibleCount).map((ordinance, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={ordinance.principalLink}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 100, m: 2 }}
                        image={ordinance.image}
                        alt={ordinance.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                        <a
                          href={ordinance.principalLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                              {<DownloadIcon />}{ordinance.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {ordinance.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publiée le {moment(ordinance.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredOrdinances.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus d'Ordonnances
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default Ordinances;